import { saveAs } from 'file-saver';
import moment from 'moment';
import { UseSnCode } from 'utils/useSnCode';
import { buildPatientExportTable, toCsv } from './patient-export-columns';

interface ExportProps {
    data: any[];
    t: any;
    toBuddhistYear: (momentObj: moment.Moment, format: string) => string;
}

const exportPatientListToCsv = async ({ data, t, toBuddhistYear }: ExportProps) => {
    const sn = await UseSnCode()

    const { headers, rows } = buildPatientExportTable(data, {
        t,
        sn: !!sn,
        formatDate: (value: any) => toBuddhistYear(moment(value), 'DD/MM/YYYY'),
    })

    const csv = toCsv([headers.map((header) => t(header)), ...rows])
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, `${t(`REPORT.REPORT_NAME.PATIENT_INFORMATION`)}.csv`);
};

export default exportPatientListToCsv;
